<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="applicant-tracker.myInterviews" [menuService]="recruitingModuleMenuService"> </app-header>

    <app-table class="table" [table]="interviewIndexTable" [useStickyHeader]="false" [showOffset]="false">
        <app-empty-state
            src="/assets/illustrations/documents.png"
            label="applicant-tracker.messages.interview.viewAndManageAssignedInterviewsFromHere"
        ></app-empty-state>
    </app-table>
</div>
